import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-complete-task',
  standalone: false,
  templateUrl: './complete-task.component.html',
  styleUrl: './complete-task.component.css',
})
export class CompleteTaskComponent {
  @Input() completedTasks: any = {
    taskCompletionImage: 'assets/images/icons/FinishTask.svg',
    taskCompletionTitle: 'Picking Task Complete',
    taskCompletionMessage:
      'Yay! You have completed the picking task \n Now, please proceed to the packing task.',
  };
  @Input() showReDirecttext: boolean = false;
}
